<template>
  <div class="header">
    <div class="nav-top">
      <div class="flex clear">
        <div class="left4 child">
          鹰瞳快速阅读
          <div class="BacDiv1"></div>
          <div class="BacDiv2"></div>
        </div>
        <div class="center4 child">
          <ul class="ulnav">
            <li
              v-for="(nav, ind) in navData"
              :key="ind"
              :class="[activeIndex == ind ? 'liActive' : 'listyle']"
              @click="handleSelect(ind)"
            >
              <span class="boder-bot">
                {{ nav }}
              </span>
            </li>
          </ul>
        </div>
        <div class="right4 child">
          <el-button type="primary" @click="clicks" v-if="userInfo === ''"
            >欢迎登录</el-button
          >
          <div class="right-flex" v-else>
            <img :src="male[imgIndex].img" alt="" />
            <!-- <img v-if="userInformation.sex === '1'" :src="female[imgIndex].img" alt="">
                        <img v-if="userInformation.sex === '2'" :src="female[imgIndex].img" alt=""> -->
            <!-- <img v-if="userInformation.sex === '2'" src="../assets/read/123.png" alt=""> -->
            <el-dropdown @command="handleCommand">
              <div class="el-dropdown-link">
                <div class="userName">{{ userName }}</div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a" icon="el-icon-s-custom"
                  >我的信息</el-dropdown-item
                >
                <el-dropdown-item command="b" icon="el-icon-s-data"
                  >我的数据</el-dropdown-item
                >
                <el-dropdown-item command="c" icon="el-icon-edit-outline"
                  >意见反馈</el-dropdown-item
                >
                <el-dropdown-item command="d" icon="el-icon-remove"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <div class="sef">
              <div class="badge" v-if="BadgeList.day !== 0">
                <img
                  v-if="BadgeList.day == 1"
                  src="../assets/badge/zhou1.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.day == 2"
                  src="../assets/badge/zhou3.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.day == 3"
                  src="../assets/badge/zhou2.png"
                  alt=""
                />
                <img v-else src="../assets/badge/zhou4.png" alt="" />
              </div>
              <div class="badge" v-if="BadgeList.month !== 0">
                <img
                  v-if="BadgeList.month == 1"
                  src="../assets/badge/yue1.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.month == 2"
                  src="../assets/badge/yue3.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.month == 3"
                  src="../assets/badge/yue2.png"
                  alt=""
                />
                <img v-else src="../assets/badge/yue4.png" alt="" />
              </div>
              <div class="badge" v-if="BadgeList.quarter !== 0">
                <img
                  v-if="BadgeList.quarter == 1"
                  src="../assets/badge/ji1.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.quarter == 2"
                  src="../assets/badge/ji2.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.quarter == 3"
                  src="../assets/badge/ji3.png"
                  alt=""
                />
                <img v-else src="../assets/badge/ji4.png" alt="" />
              </div>
              <div class="badge" v-if="BadgeList.year !== 0">
                <img
                  v-if="BadgeList.year == 1"
                  src="../assets/badge/nian1.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.year == 2"
                  src="../assets/badge/nian2.png"
                  alt=""
                />
                <img
                  v-else-if="BadgeList.year == 3"
                  src="../assets/badge/nian3.png"
                  alt=""
                />
                <img v-else src="../assets/badge/nian4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login
      :getSchoolName="getSchoolName"
      @event="submintLogin"
      v-if="showTextmsg"
    ></login>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { throttle } from "./throttle";
import { login } from "@/api/Login";
import {
  nav,
  getInformation,
  outLogin,
  querySearchMedal,
  queryLimitsAuthority,
  addLogininfor,
} from "@/api/home/nav";
export default {
  components: {
    // myLogin,
  },
  data() {
    return {
      activeIndex: 0,
      navData: ["首页", "训练", "课程", "阅读", "比赛", "考试"],
      showTextmsg: false,
      textmsg: {
        state: 2,
      },
      log: true,
      userInfo: "",
      imgIndex: 0,
      userInformation: "",
      male: [
        {
          img: require("../assets/sculpture/girl1.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/girl2.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/girl3.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/girl4.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/girl5.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/girl5.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy1.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy2.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy3.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy4.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy5.png"),
          selected: false,
        },
        {
          img: require("../assets/sculpture/boy6.png"),
          selected: false,
        },
      ],
      female: [],
      BadgeList: "",
      userName: "",
    };
  },
  watch: {},
  mounted() {
    this.activeIndex = sessionStorage.getItem("activeIndex");
    if (this.activeIndex === null) {
      this.activeIndex = 0;
    }
    if (this.activeIndex === 0) this.$router.push({ path: "home" });
    if (this.activeIndex === 1) this.$router.push({ path: "train" });
    if (this.activeIndex === 2) this.$router.push({ path: "course" });
    if (this.activeIndex === 3) this.$router.push({ path: "read" });
    if (this.activeIndex === 4) this.$router.push({ path: "petition" });
    if (this.activeIndex === 5) this.$router.push({ path: "examination" });
    this.listen();
  },
  created() {
    //   this.navigation()
  },
  methods: {
    navigation() {
      nav().then((res) => {
        this.navData = res.rows;
      });
    },
    listen() {
      let user = JSON.parse(sessionStorage.getItem("userInfo"));
      if (user != null) {
        this.userInfo = user;
        getInformation(this.userInfo.memberId).then((res) => {
          //  console.log('个人信息',res)
          this.userName = res.data.name;
          if (res.data.headImg !== null) {
            this.imgIndex = res.data.headImg;
          } else {
            sessionStorage.setItem("headImg", 1);
            if (res.data.sex === "0") {
              this.imgIndex = 6;
            } else if (res.data.sex === "1") {
              this.imgIndex = 0;
            } else {
              this.imgIndex = 0;
            }
          }
          this.userInformation = res.data;
          //  nextLevel  0:无权限   1：有权限
          sessionStorage.setItem("nextLevel", res.data.nextLevel);
        });
        this.gerMoser();
        this.competence(this.userInfo.memberId);
      }
    },
    gerMoser() {
      let data = JSON.parse(sessionStorage.getItem("userInfo"));
      let obj = {
        memberId: data.memberId,
        code: 1,
      };
      querySearchMedal(obj).then((res) => {
        this.BadgeList = res.data;
      });
    },
    /*查询进入权限*/
    competence(memberId) {
      queryLimitsAuthority(memberId).then((res) => {
        // console.log('权限',res)
        sessionStorage.setItem("autonomous", JSON.stringify(res.data));
      });
    },
    handleSelect(key, keyPath) {
      let verify = JSON.parse(sessionStorage.getItem("userInfo"));
      if (verify != null && key != 0) {
        this.userInfo = verify;
        getInformation(this.userInfo.memberId).then((res) => {
          // console.log("个人信息333333", res);
          if (res.data.headImg == null) {
            this.$message({
              message: "首次登录，请完善个人信息。",
              type: "warning",
              showClose: true,
            });
            this.$router.push("/information");
          }
        });
      }
      if (key === 0) {
        this.$router.push({ path: "home" });
      }
      if (key === 1) {
        if (verify === null) {
          this.showTextmsg = true;
          return;
        }
        this.$router.push({ path: "train" });
      }
      if (key === 2) {
        this.$router.push({ path: "course" });
      }
      if (key === 3) {
        if (verify === null) {
          this.showTextmsg = true;
          return;
        }
        this.$router.push({ path: "read" });
      }
      if (key === 4) {
        if (verify === null) {
          this.showTextmsg = true;
          return;
        }
        this.$router.push({ path: "petition" });
      }
      if (key === 5) {
        if (verify === null) {
          this.showTextmsg = true;
          return;
        }
        this.$router.push({ path: "examination" });
      }
      sessionStorage.setItem("activeIndex", key);
      this.activeIndex = key;
    },

    clicks() {
      this.showTextmsg = true;
    },
    getSchoolName(name) {
      this.showTextmsg = false;
      // console.log("收到的状态:", name)
    },
    submintLogin: throttle(async function (data) {
      let sumit = JSON.parse(data);
      if (sumit.memberPassword === "" || sumit.name === "") return;
      sumit.memberPassword = this.$Base64.encode(sumit.memberPassword);
      let res = await login(sumit);
      //   login(sumit).then((res) => {
      if (res.code == 200) {
        let obj = {
          activState: res.activState,
          memberId: res.memberId,
          userName: sumit.name,
        };
        await sessionStorage.setItem("userInfo", JSON.stringify(obj));
        await sessionStorage.setItem("token", res.token);
        // 添加登录日志
        let obj1 = {
          userName: sumit.name,
          msg: "登录成功",
          loginTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };
        await addLogininfor(obj1);
        // addLogininfor(obj1).then((res) => {});
        this.$message({
          message: "登录成功",
          type: "success",
        });
        location.reload();
      } else {
        this.$message.error(res.msg);
      }
      //   });
    }, 1500),

    handleCommand(command) {
      if (command === "a") {
        this.$router.push({ path: "information" });
      }
      if (command === "b") {
        this.$router.push({ path: "statistics" });
      }
      if (command === "c") {
        this.$router.push({ path: "opinion" });
      }
      if (command === "d") {
        this.$confirm("确定退出登录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let data = JSON.parse(sessionStorage.getItem("userInfo"));
            let obj = {
              userName: data.userName,
              msg: "退出成功",
              loginTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            };
            outLogin().then((res) => {
              addLogininfor(obj).then((res) => {
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("activeIndex");
                sessionStorage.removeItem("nextLevel");
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("autonomous");
                sessionStorage.removeItem("headImg");
                sessionStorage.removeItem("courseDetail");
                location.reload();
              });
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}

.nav-top {
  width: 100%;
  height: 60px;
  margin: 0 auto;

  /* // background-color: #FFFFFF; */
  .clear:after {
    content: "";
    display: block;
    height: 60px;
    clear: both;
  }

  /*flex*/
  .flex {
    display: box;
    display: -webkit-box;
    display: -moz-box;
  }
  .left4 {
    width: 25%;
    height: 60px;
    color: #ffffff;
    text-align: right;
    font-size: 1.125rem;
    padding-right: 50px;
    background: linear-gradient(to right, #d5ebfe, #2f8ffd);
    position: relative;
  }
  .BacDiv1 {
    width: 27px;
    height: 60px;
    background: #3794fd;
    position: absolute;
    top: 0;
    left: 0;
  }
  .BacDiv2 {
    width: 8px;
    height: 60px;
    background: #3794fd;
    position: absolute;
    top: 0;
    left: 37px;
  }
  .right4 {
    padding-right: 5%;
    height: 60px;
    position: absolute;
    right: 0;
    //vertical-align: top;
    .right-flex {
      width: 100%;
      display: flex;
      align-items: center;
    }

    img {
      width: 5vh;
      height: 5vh;
      border-radius: 50%;
    }
  }

  .center4 {
    width: 50%;
    //box-flex: 1;
    //-webkit-box-flex: 1;
    //-moz-box-flex: 1;
  }

  .sef {
    height: 60px;
    display: flex;
    align-items: center;
    .badge {
      float: left;
      img {
        width: 5vh;
        height: 5vh;
        vertical-align: middle;
      }
    }
  }
  .ulnav {
    //display: box;
    //display: -webkit-box;
    //display: -moz-box;
    list-style-type: none;
  }

  /* // boder-bot */
  .listyle {
    //width: 100px;
    width: 10%;
    float: left;
  }

  .liActive {
    //width: 100px;
    width: 10%;
    float: left;

    span {
      color: #409eff;
      font-size: 1.125rem;
      padding-bottom: 5px;
      border-bottom: 2px solid #409eff;
    }
  }
}

.el-dropdown {
  //width: 25%;
  .el-dropdown-link {
    //width: 100%;
    //min-width: 60px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    .userName {
    }
  }
}

.logo-img {
  width: 15%;
  height: 60px;
  color: #ffffff;
  background: #2489fd;
  line-height: 60px;
  text-align: center;
  float: left;
  vertical-align: top;
}

::v-deep .el-menu {
  width: 55%;
  height: 60px;
  float: left;
  margin-left: 50px;
  border: 0 !important;
  color: #000000 !important;
  background-color: rgba(0, 0, 0, 0);

  .el-menu-item:hover {
    outline: 0 !important;
    color: #409eff !important;
    background: none !important;
  }

  .el-menu-item {
    width: 100px;
    color: #000000;
    padding: 0;
    border-bottom: none !important;
  }

  .el-menu-item.is-active {
    color: #ffffff !important;
    font-size: 17px;
    border-bottom: none !important;
    background: #409eff !important;
  }
}
</style>